import SendbirdChat from '@sendbird/chat'
import { GroupChannelModule } from '@sendbird/chat/groupChannel'
import { OpenChannelModule } from '@sendbird/chat/openChannel'

const APP_ID = 'ACF7E89A-DDC5-4EED-8BCC-45D78423582F'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
let sendbirdInstance: any = null

export const initSendbird = () => {
	if (!sendbirdInstance) {
		sendbirdInstance = SendbirdChat.init({
			appId: APP_ID,
			modules: [
				new GroupChannelModule(),
				new OpenChannelModule()
			],
			localCacheEnabled: false
		})
	}
	return sendbirdInstance
}

export const getSendbird = () => {
	return sendbirdInstance
}

export const connectUser = async (userId: string, accessToken?: string): Promise<void> => {
	const sb = initSendbird()
	if (accessToken) {
		await sb.connect(userId, accessToken)
	} else {
		await sb.connect(userId)
	}
}

export const disconnectUser = async (): Promise<void> => {
	const sb = getSendbird()
	if (sb) {
		await sb.disconnect()
	}
}

export default {
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	install(Vue: any) {
		Vue.prototype.$sendbird = {
			init: initSendbird,
			get: getSendbird,
			connect: connectUser,
			disconnect: disconnectUser
		}
	}
}
